import { render, staticRenderFns } from "./level_t.vue?vue&type=template&id=01fe16dc&scoped=true&"
import script from "./level_t.vue?vue&type=script&lang=js&"
export * from "./level_t.vue?vue&type=script&lang=js&"
import style0 from "./level_t.vue?vue&type=style&index=0&id=01fe16dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe16dc",
  null
  
)

export default component.exports